<p>privacy works!</p>
<div class="privacy-container">

  <h1 class="titolo">Privacy</h1>

  <p class="testo-grassetto">
    INFORMATIVA ESTESA AI SENSI DEGLI ARTT. 12, 13 E 14 DEL GDPR – REGOLAMENTO (UE) 2016/679
  </p>

  <p class="testo-completo">

    Il titolare del trattamento riporta di seguito l’Informativa ai sensi degli artt. 12, 13 e 14 del GDPR relativa
    al trattamento dei dati personali forniti tramite compilazione del form o navigazione sul sito.

    <br><br><strong>1. Titolare del trattamento e dati di contatto</strong><br>
    Titolare: <strong>SAMI S.R.L.S.</strong><br>
    Sede: Via Osento 21 – 65128 – Pescara (PE)<br>
    P.IVA: 02221160688<br>
    Email: samyimpresadipulizie@gmail.com<br>
    Sito Web: www.samypulizie.it

    <br><br><strong>2. Principi applicabili al trattamento</strong><br>
    I dati personali sono trattati secondo i principi di liceità, correttezza, trasparenza, minimizzazione, esattezza,
    integrità, riservatezza e limitazione della conservazione, come previsto dal GDPR.

    <br><br><strong>3. Modalità di trattamento</strong><br>
    Il trattamento avviene tramite strumenti manuali e informatici, garantendo sicurezza e riservatezza.

    <br><br><strong>4a. Finalità per cui il trattamento è necessario</strong><br>
    I dati sono trattati per:
    – Esecuzione del contratto e richieste di preventivo  
    – Adempimento di obblighi legali  
    – Tutela di interessi vitali  
    – Legittimo interesse del titolare

    <br><br><strong>4b. Ulteriori finalità previo consenso</strong><br>
    Con consenso esplicito dell’interessato i dati possono essere usati per:
    – Comunicazioni commerciali  
    – Marketing diretto  
    – Invio promozioni o newsletter

    <br><br><strong>5. Tipologie di dati trattati</strong><br>
    Dati identificativi, contatti, dati per preventivi, dati tecnici di navigazione e cookie.

    <br><br><strong>6. Fonte dei dati</strong><br>
    I dati provengono dall’utente tramite form, contatto diretto o navigazione web.

    <br><br><strong>7. Interessi legittimi</strong><br>
    Il trattamento può basarsi sul legittimo interesse del titolare per prevenzione frodi, sicurezza sistemi, uso interno aziendale.

    <br><br><strong>8a. Comunicazione dei dati</strong><br>
    I dati possono essere comunicati a:
    – Partner tecnici  
    – Servizi IT  
    – Professionisti incaricati  
    – Banche / servizi finanziari  
    – Autorità competenti

    <br><br><strong>8.1 Cloudflare Turnstile</strong><br>
    I moduli del sito utilizzano Cloudflare Turnstile per prevenire invii automatizzati e abusi. Il servizio
    analizza segnali tecnici del browser e della connessione. Maggiori informazioni sono disponibili nella
    <a href="https://www.cloudflare.com/policies/privacy/" target="_blank" rel="noopener">Privacy Policy di Cloudflare</a>
    e nel relativo Turnstile Privacy Addendum.

    <br><br><strong>8b. Trasferimento verso paesi terzi</strong><br>
    Possibile solo con garanzie adeguate ai sensi dell’art. 46 GDPR.

    <br><br><strong>9. Periodo di conservazione</strong><br>
    – Fino a 10 anni per obblighi legali e contrattuali<br>
    – Fino a revoca consenso per finalità marketing

    <br><br><strong>10. Diritti dell’interessato</strong><br>
    L’utente può richiedere: accesso, rettifica, cancellazione, limitazione, portabilità, opposizione e revoca del consenso.

    <br><br>
    Può inoltre proporre reclamo al Garante della Privacy.

    <br><br><strong>11. Sicurezza</strong><br>
    Sono adottate misure tecniche e organizzative adeguate. Nessun sistema è sicuro al 100%, ma vengono applicate tutte le
    misure previste dalla normativa.

    <br><br><strong>12. Processi automatizzati</strong><br>
    Potrebbe esserci profilazione leggera per migliorare esperienza d’uso (mai decisioni automatizzate con effetti giuridici).

  </p>

</div>
